import { useAuthStore } from '@/stores/auth-store'

const TODAY = new Date().toLocaleDateString('id-ID', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export default function DashboardPage() {
  const user = useAuthStore((s) => s.user)

  const displayName = user?.display_name ?? user?.email ?? 'Pengguna'

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Selamat Datang, {displayName}</h1>
        <p className="text-sm text-muted-foreground capitalize">{TODAY}</p>
      </div>

      <div className="rounded-xl border border-border bg-card p-6">
        <p className="text-sm text-muted-foreground">
          Dashboard siap dikembangkan. Mulai tambahkan fitur sesuai kebutuhan aplikasi.
        </p>
      </div>
    </div>
  )
}
